import React, { PropsWithChildren, createContext, useContext } from 'react';
import { useChartSort } from '../hooks/useChartSort';
import { SortBy } from '../domain';
import { BarSeriesValue } from '~/MedicinalBrandsAnalytics/Region/reducer';
import { ErpStatsResponse } from 'com.cogvio.pricemonitor.api';

interface SortingContextProps {
	sortBy: SortBy;
	handleSortChange: () => void;
	sortSeries: (series: BarSeriesValue[]) => BarSeriesValue[];
	sortCategories: (series: BarSeriesValue[], stats: ErpStatsResponse) => string[];
}

const SortingContext = createContext<SortingContextProps>({
	sortBy: SortBy.PRICE,
	handleSortChange: () => void 0,
	sortSeries: () => [],
	sortCategories: () => [],
});

export function SortingContextProvider({ children }: PropsWithChildren<Record<never, never>>) {
	const sort = useChartSort();
	return <SortingContext.Provider value={sort}>{children}</SortingContext.Provider>;
}

export function useSortingContext() {
	return useContext(SortingContext);
}
